import type { PopupSettings } from '@skeletonlabs/skeleton';

export function GetHoverPopupSettings(popupName: string | number): PopupSettings {
  return {
    event: 'hover',
    target: popupName.toString(),
    placement: 'top',
  };
}
export function GetClickPopupSettings(popupName: string | number): PopupSettings {
  return {
    event: 'click',
    target: popupName.toString(),
    placement: 'top',
  };
}
